'use strict';

wbApp.factory('actionDetailSvc', [
    '$http', 'notificationSvc', '$translate', 'courseRegistrationCommonSvc',
    function ($http, notificationSvc, $translate, courseRegistrationCommonSvc) {

        //var model = courseRegistrationCommonSvc.prepareModelAsync(action, true); // external dependency
        //// model : { action: ..., studetns: [] }

        //function getActionDetail() {
        //    return model;
        //}

        function registerOnAction(courseID, students, onSuccess, onError) {
            $http({
                method: 'POST',
                url: '/Actions/Register',
                data: { courseID: courseID, students: students }
            })
            .success(function (actionDetail, status, headers, config) {

                model = courseRegistrationCommonSvc.prepareModelAsync(actionDetail, true);
                model.$promise.then(function (result) {
                    if (onSuccess) {
                        onSuccess(model);
                    }

                    notificationSvc.notifyInfo(
                        $translate.instant('TXT_ALERT_TITLE_ACTION_REGISTRATION_SUCCESS'));
                });
            })
            .error(function (errorResult, status, headers, config) {
                if (onError) {
                    onError(errorResult);
                }

                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ACTION_REGISTRATION_FAILURE'),
                    notificationSvc.translateError(errorResult));
            });
        }

        function setUpActionPrices(action, students) {
            return courseRegistrationCommonSvc.setUpCoursePrices(action, students);
        }

        function getConfirmRegistrationStudents(students, origStudents) {
            return courseRegistrationCommonSvc.getConfirmRegistrationStudents(students, origStudents, true);
        }

        function getConfirmRegistrationDescription(students, origStudents, action) {
            return courseRegistrationCommonSvc.getConfirmRegistrationDescription(students, origStudents, action, true);
        }

        function updatePriceDetails(action, student) {
            courseRegistrationCommonSvc.updatePriceDetails(action, student);
        }

        return {
           // getActionDetail: getActionDetail,
            registerOnAction: registerOnAction,
            setUpActionPrices: setUpActionPrices,
            updatePriceDetails: updatePriceDetails,
            getConfirmRegistrationStudents: getConfirmRegistrationStudents,
            getConfirmRegistrationDescription: getConfirmRegistrationDescription
        }
    }]);
